import { Crumb } from "@metablock/react";

export const breadcrumbs = (...texts: string[]): Crumb[] => {
  const bits = location.pathname.split("/").filter((v: string) => v);
  const text =
    bits.length && texts.length
      ? bits.slice(0, -texts.length).concat(texts)
      : bits;
  let url = "";
  return bits.map((bit: string, index: number) => {
    const crumb: Crumb = { text: text[index] };
    if (index < bits.length - 1) {
      url = `${url}/${bit}`;
      crumb.to = url;
    }
    return crumb;
  });
};

export const getTab = (tabs: Crumb[], pathname: string): string => {
  let tabIndex = "";
  tabs.forEach((crumb: Crumb) => {
    if (crumb.to) {
      const n = crumb.to.length;
      if (n > tabIndex.length && pathname.substring(0, n) === crumb.to)
        tabIndex = crumb.to;
    }
  });
  return tabIndex;
};
